import React, { useContext, useEffect, useMemo } from "react";
import "./index.scss";
import FormulaGenerator from "../../../FormulaGenerator";
import { getStepInfo } from "../../stepInfo";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const FixedProstheticsSelectSuspendedTooth = ({
  stepId,
  toggleNextBtnState
}) => {
  const {
    language
  } = useTranslation();
  const {
    isPatient,
    dentalData,
    setStepFormula
  } = useContext(StepContext);

  function setData(data) {
    setStepFormula(stepId, data);
  } // Disable next btn


  useEffect(() => {
    if (isPatient && (!dentalData || !dentalData.hasOwnProperty("tooth") || !dentalData.tooth.some(tooth => tooth.toothElementsActive.some(el => el === "plasticTooth")))) {
      toggleNextBtnState(true);
    } else {
      toggleNextBtnState(false);
    }
  }, [dentalData, toggleNextBtnState, isPatient]);
  const formulaHelperText = useMemo(() => {
    return getStepInfo(language, stepId)?.formulaHelperText || "";
  }, [language, stepId]);
  return /*#__PURE__*/React.createElement("div", {
    className: "fixedProstheticsSelectSuspendedTooth"
  }, /*#__PURE__*/React.createElement(FormulaGenerator, {
    projectData: dentalData,
    setProjectDentalData: setData,
    initialSelection: "fixedProstheticsSelectSuspendedTooth",
    availableSwitchers: ["top", "bottom", "base", "fixedProstheses"],
    formulaHelperText: formulaHelperText
  }));
};

export default FixedProstheticsSelectSuspendedTooth;